import { FormSectionLayout } from "@homebound/beam";
import {
  BaseChangeEventFormInput,
  BaseChangeEventFormState,
} from "src/routes/projects/change-events/guided/baseChangeEventForm";
import { GuidedChangeEventStep } from "src/routes/projects/change-events/guided/utils";
import { ReviewStep } from "src/routes/projects/change-events/guided/workflows/sharedSteps/ReviewStep";
import { WorkflowStep } from "src/routes/projects/change-events/guided/workflows/types";

/**
 * Placeholder shown for steps that aren't built yet. Still renders the step's own
 * `FormSectionLayout` so the empty step keeps the same centered column as a real one.
 */
export function NotInPrototypeYet(props: { title: string }) {
  const { title } = props;
  return <FormSectionLayout title={title} description="This step is not part of the prototype yet." sections={[]} />;
}

// Downstream steps common to every workflow. Generic factories so `F` is inferred from the
// workflow's `steps` array they are spread into (`ObjectState<F>` is invariant in `F`, so a
// single shared constant can't be assigned across different form shapes).
export function reviewImpactStep<F>(): WorkflowStep<F> {
  return {
    value: GuidedChangeEventStep.ReviewImpact,
    label: "Review Impact",
    isComplete: () => false,
    disabled: () => true,
    render: () => <NotInPrototypeYet title="Review Impact" />,
  };
}

export function reviewStep<F extends BaseChangeEventFormInput>(): WorkflowStep<F> {
  return {
    value: GuidedChangeEventStep.Review,
    label: "Review",
    isComplete: (form) => form.valid,
    render: (form) => <ReviewStep formState={form as BaseChangeEventFormState<F>} />,
  };
}
